import { Breakpoints, Colors, Spacing } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'
import { CLOUDFLARE_RESPONSIVE_BASE } from '../../../../../../constants'
import { Placeholder } from './Placeholder'

const ImageWidth = {
  Small: Breakpoints.Mobile,
  Large: Breakpoints.Tablet,
  Small2x: Breakpoints.Desktop,
  Large2x: Breakpoints.UltraWideScreen,
}

const ImageHeight = {
  Small: 288,
  Large: 556,
}

const StyledImg = styled.img`
  box-sizing: border-box;
  border: 1px solid ${Colors.SystemGrey20};
  border-radius: ${Spacing.XxSmall}px;
`

const buildUrl = (width, quality, path) =>
  `${CLOUDFLARE_RESPONSIVE_BASE}/width=${width},quality=${quality}/managed/dasher/growth/background-check/abn/${path}`

// source set urls for different image sizes
const getSrcSet = path =>
  Object.values(ImageWidth)
    .map(width => `${buildUrl(width, 75, path)} ${width}w`)
    .join(',')

const sizes = `(max-width: 600px) ${ImageWidth.Small}px,${ImageWidth.Large}px`

interface ImageProps {
  url: string
  title: string
}

export function AbnImage({ url, title }: ImageProps) {
  const [isLoading, setIsLoading] = React.useState(true)

  return (
    <Placeholder
      isLoading={isLoading}
      smHeight={ImageHeight.Small}
      lHeight={ImageHeight.Large}
    >
      <StyledImg
        srcSet={getSrcSet(url)}
        sizes={sizes}
        alt={title}
        width="100%"
        style={isLoading ? { display: 'none' } : {}}
        onLoad={() => setIsLoading(false)}
      />
    </Placeholder>
  )
}
